import React, {ReactElement, useMemo} from 'react';
import {convertFromRaw} from "draft-js";
import {stateToHTML} from "draft-js-export-html";
import TableTextEditor from "../fields/TableTextEditor";
import Box from "@mui/material/Box";

const parseJsonToEditorState = (jsonData: any) => {
  const contentState = convertFromRaw(JSON.parse(jsonData)); // Visszaalakítjuk a JSON-t ContentState-re
  const html = stateToHTML(contentState); // A ContentState HTML-re alakítása
  return html;
};

const isJsonString = (str: string): boolean => {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
};

export const RichTextEditCell = ({
  props,
  schema,
  column,
}: {
  props: any;
  schema: any;
  column: any;
}): ReactElement => {
  const defaultValue = props.value ? props.value : '';

  const handleEditorChange = (updatedHtml: any) => {
    if (defaultValue === updatedHtml) {
      return;
    }

    props.api.setEditCellValue({
      id: props.id,
      field: props.field,
      value: updatedHtml,
    });

    return;
  };

  const initialHtml = useMemo(() => {
    if (isJsonString(defaultValue) && defaultValue) {
      return parseJsonToEditorState(defaultValue);
    } else {
      return defaultValue ? defaultValue : '';
    }
  }, []);


  return (
    <>
      <Box
      sx={{
        '& .rdw-editor-wrapper': {
          position: 'initial'
        },
        width: '100%'
      }}>
        <TableTextEditor
          initialHtml={initialHtml}
          column={column}
          onChange={handleEditorChange}
          debounceMs={0}
        />
      </Box>
    </>
  );
};
